<template>
  <div class="input-file-container">
    <CloseButton v-if="image" class="close_button" @handleClick="handleFileDelete()"></CloseButton>
    <div v-if="image" class="img" :style="{ backgroundImage: `url(${image})` }"></div>
    <span v-else class="placeholder">Add image</span>
    <input class="input-file" type="file" :disabled="disabled" @change="handleFileChange($event)">
  </div>
</template>

<script>
import CloseButton from '@/components/atoms/CloseButton.vue';

export default {
  components: {
    CloseButton,
  },

  props: {
    image: {
      type: String,
      default: null,
    },
    index: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleFileChange(event) {
      this.$emit('handleFileChange', {
        index: this.index,
        event,
      });
    },
    handleFileDelete() {
      // event.preventDefault();
      // event.stopPropagation();
      this.$emit('handleFileDelete', {
        index: this.index,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.input-file-container {
  position: relative;
  display: flex;
  width: 140px;
  height: 140px;
  padding: 0px;
  color: $black;
  border-radius: 2px;
  margin: 5px;
  position: relative;

  .close_button {
    background-color: $white;
    position: absolute;
    right: 0;
    height: 34px;
    border-radius: 100px;
    width: 34px;
    padding-left: 2px;
    padding-top: 15px;
    z-index: 2;
  }

  .img {
    width: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .placeholder {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: 24px;
    font-weight: bold;
    line-height: 20px;
    color: $gray;
    background: $white;
  }

  .input-file {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }

  .input {
    margin-left: 10px;
  }
}
</style>
